import React, { Component } from "react";
import Radium from "radium";
import PropTypes from "prop-types";

import Styles from "./MinimapPortal.styles";

class MinimapPortal extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.sceneId);
  }
  render() {
    const selectedStyle = this.props.selected ? Styles.selected : {};
    return (
      <div
        tabIndex={-1}
        style={[
          Styles.portalBase,
          Styles.portal(this.props.positionX, this.props.positionY, this.props.color),
          selectedStyle
        ]}
        onClick={this.onClick}
        onTouchStart={this.onClick}
      />
    );
  }
}

MinimapPortal.defaultProps = {
  selected: false
};
MinimapPortal.propTypes = {
  positionX: PropTypes.number.isRequired,
  positionY: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  sceneId: PropTypes.string.isRequired
};

export default Radium(MinimapPortal);



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMinimap/MinimapPortal/MinimapPortal.js